import {
  FETCH_LEAVE_ADJUSTMENTS_REQUEST, FETCH_LEAVE_ADJUSTMENTS_SUCCESS, FETCH_LEAVE_ADJUSTMENTS_FAIL,
  CLEAR_LEAVE_ADJUSTMENTS,
  ADD_LEAVE_ADJUSTMENT_REQUEST, ADD_LEAVE_ADJUSTMENT_SUCCESS, ADD_LEAVE_ADJUSTMENT_FAIL,
} from "../../constants/Leave/LeaveAdjustmentConstants";

const initialState = {
  loading: false,
  data: [],      // adjustments of the employee currently selected on the page
  error: null,
  adding: false,
};

const LeaveAdjustmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LEAVE_ADJUSTMENTS_REQUEST:
      return { ...state, loading: true, error: null, data: [] };
    case FETCH_LEAVE_ADJUSTMENTS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case FETCH_LEAVE_ADJUSTMENTS_FAIL:
      return { ...state, loading: false, data: [], error: action.payload };
    case CLEAR_LEAVE_ADJUSTMENTS:
      return { ...state, loading: false, data: [], error: null };

    case ADD_LEAVE_ADJUSTMENT_REQUEST:
      return { ...state, adding: true };
    case ADD_LEAVE_ADJUSTMENT_SUCCESS:
    case ADD_LEAVE_ADJUSTMENT_FAIL:
      return { ...state, adding: false };

    default:
      return state;
  }
};

export default LeaveAdjustmentReducer;